import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/ic-arrow-back.svg'


const _hoisted_1 = { class: "page__header" }
const _hoisted_2 = { class: "page__header-title" }
const _hoisted_3 = {
  class: "page__stats",
  style: `display: flex; justify-content: space-between`
}
const _hoisted_4 = { class: "md" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Торговое наименование", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Юридическое наименование", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "ИНН налогоплательщика", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "СНО", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Налоговая регистрация", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Вид деятельности", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Наличие ККМ", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Кол-во ККМ", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "Модели ККМ", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "Номер РНМ", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "Модели ККМ", -1)
const _hoisted_23 = { rowspan: "1" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "Номер РНМ", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "Телефон управляющего", -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, "Кол-во сотрудников", -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, "Торговая площадь, кв.м", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, "Вид объекта", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, "Дата внесения изменений", -1)
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "Дата последнего перевода в статус \"ликвидирован\"", -1)
const _hoisted_36 = { key: 3 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "Инспектор, сменивший статус", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, "Сдается в аренду", -1)
const _hoisted_39 = { key: 4 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, "Сумма аренды в месяц (сом)", -1)
const _hoisted_41 = {
  key: 0,
  style: `display: flex; align-items: center; flex-direction: column`
}
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 0,
  class: "page__photo-wrapper"
}
const _hoisted_44 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSelector = _resolveComponent("UiSelector")!
  const _component_UiInput = _resolveComponent("UiInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "page__header-back",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.values?.objectName), 1),
        _createElementVNode("div", {
          class: "page__header-status",
          style: _normalizeStyle(`background: ${_ctx.statusColor}`)
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.objectName || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.subBusinessName || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.inn || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, [
              (!_ctx.form.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.info.values?.nalogRegime?.subType || _ctx.info.values?.nalogRegime?.type || _ctx.info.values?.nalogRegime?.name  || 'не задано'), 1))
                : (_openBlock(), _createBlock(_component_UiSelector, {
                    key: 1,
                    placeholder: "Выберите СНО",
                    modelValue: _ctx.form.values.nalogRegime,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.values.nalogRegime) = $event)),
                    options: _ctx.form.options.nalogRegime
                  }, null, 8, ["modelValue", "options"]))
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.ugnsTno?.ugnsTnoCode || _ctx.info.values?.ugnsTno?.regionCity || _ctx.info.values?.ugnsTno?.name || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.activityType?.value || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, [
              (!_ctx.form.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.info.values?.kkmBso ? 'ДА' : 'НЕТ'), 1))
                : (_openBlock(), _createBlock(_component_UiSelector, {
                    key: 1,
                    placeholder: "Наличие ККМ",
                    modelValue: _ctx.form.values.kkmUse,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.values.kkmUse) = $event)),
                    options: _ctx.form.options.kkmUse,
                    useSearch: false
                  }, null, 8, ["modelValue", "options"]))
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("td", null, [
              (!_ctx.form.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.info.values?.kkmCount || '0'), 1))
                : (_openBlock(), _createBlock(_component_UiInput, {
                    key: 1,
                    placeholder: "Кол-во ККМ",
                    type: "number",
                    min: "0",
                    modelValue: _ctx.form.values.kkmCount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.values.kkmCount) = $event))
                  }, null, 8, ["modelValue"]))
            ])
          ]),
          (_ctx.info.values?.kkmModel && !_ctx.info.values.kkmModels.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("td", null, [
                  (!_ctx.form.open)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.info.values?.kkmModel?.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.values?.kkmModel && !_ctx.info.values.kkmModels.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("td", null, [
                  (!_ctx.form.open)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.info.values?.rnmNum ?? 'не задано'), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.values?.kkmModels, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              _createElementVNode("tr", null, [
                _hoisted_22,
                _createElementVNode("td", _hoisted_23, [
                  (!_ctx.form.open)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.kkmModel?.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_25,
                _createElementVNode("td", null, [
                  (!_ctx.form.open)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item?.rnmNum ?? 'не задано'), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_27,
            _createElementVNode("td", null, [
              (!_ctx.form.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.info.values?.managerPhone ?? 'не задано'), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_29,
            _createElementVNode("td", null, [
              (!_ctx.form.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.info.values?.workersCount ?? 'не задано'), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_31,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.area || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_32,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.businessType?.value || 'не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_33,
            _createElementVNode("td", null, _toDisplayString(_ctx.parseDate(_ctx.info.values?.changeDate || _ctx.info.values?.createDate) || 'недоступна'), 1)
          ]),
          (_ctx.info.values?.objectStatusLiquidatedInfo?.lastChangeDate)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("td", null, _toDisplayString(_ctx.parseDate(_ctx.info.values?.objectStatusLiquidatedInfo?.lastChangeDate)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.info.values?.objectStatusLiquidatedInfo?.fio)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.objectStatusLiquidatedInfo?.fio), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_38,
            _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.isRent ? 'Да' : 'Нет'), 1)
          ]),
          (_ctx.info.values?.isRent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("td", null, _toDisplayString(_ctx.info.values?.rentAmount || 0), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.info.qrCode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("img", {
                class: "page__photo",
                src: _ctx.info.qrCode,
                style: `width: 45%`
              }, null, 8, _hoisted_42),
              _createElementVNode("a", {
                class: "reports__download",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.info.downloadQrCode()), ["prevent"])),
                style: `margin: 15px`
              }, "Скачать")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.info.photo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("img", {
            class: "page__photo",
            src: _ctx.info.photo
          }, null, 8, _hoisted_44)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}